import React, { MouseEvent } from "react";
import Window from "./Window";
import Common from "../Common";
import ProvablyFair from "./ProvablyFair";

import "./CheckFairness.css";

export default class CheckFairness extends React.Component<CheckFairness.Props, CheckFairness.State>
{


    constructor(props: CheckFairness.Props)
    {
        super(props);

        this.state = {
            data: null
        }
    }


    componentDidMount()
    {
        // setTimeout(() => {
        //     this.setState({
        //         data: {
        //             timestamp: "2-1-2012 12:33:21",
        //             serverSeed: "XKX85pyGi6lNEUcMnYCvrrK1e99UUkXxqiVrkAsb",
        //             playerSeeds: [
        //                 {user: "j***3", seed: "2Q0EpmkaSgg1qZZPkVla-49"}
        //             ],
        //             sha: "ff8ca3df9ee1687efeffabd32b9c13a707a8b7ea7d007d427e1241444608ecc05c187cd026ca98c954bc2ef5f4ce5acb32fce46281af428a0b025f93862de983",
        //             hex: "ff8ca3df9ee16",
        //             dec: "4495672157531670",
        //             roundMultiplier: 551.05
        //         }
        //     })
        // }, 1000)
    }


    selectAll(event: MouseEvent<HTMLInputElement>)
    {
        event.currentTarget.setSelectionRange(0, event.currentTarget.value.length);
    }


    clickFair()
    {
        app.addWindow(<ProvablyFair/>);
    }


    renderHeader()
    {
        const lang = window.lang.shared;
        return (
            <>
                <div className="label">
                    {lang.round} {this.props.roundId}
                    {this.renderMultiplier()}
                </div>
            </>
        );
    }


    renderMultiplier()
    {
        if (this.state.data)
        {
            return (
                <>
                    <div className="mult">
                        {Common.renderMultiplier(this.state.data.roundMultiplier)}
                    </div>
                    <div className="time">
                        {Common.parseDate(this.state.data.timestamp, "time_full", true)}
                    </div>
                </>
            );
        }
        else
        {
            return (<></>);
        }
    }

    
    render()
    {
        const lang = window.lang.shared.modals.fairness;
        const lShared = window.lang.shared;
        return (
            <Window
                title={lShared.round + " 1234"}
                header={this.renderHeader()}
                id="checkFairness"
            >
                <div className="content">
                    {this.renderContent()}
                </div>

                <div className="footer">
                    <div>
                        {lang.help}
                        <span 
                            className="link"
                            onClick={this.clickFair.bind(this)}
                        >
                            {lShared.what_is_provably_fair}
                        </span>
                    </div>
                </div>
                
            </Window>
        );
    }


    renderContent()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader"></div>
            )
        }

        const lang = window.lang.shared.modals["fairness"];
        const data = this.state.data;

        return (
            <>
                <div className="section server">
                    <div className="header">
                        <div className="icon"></div>
                        <div className="description">
                            <div className="title">
                                {lang["server seed"]}
                            </div>
                            <div className="value">
                                {lang["server tip"]}
                            </div>
                        </div>
                    </div>
                    <div className="list">
                        <div className="item">
                            <input 
                                type="text"
                                value={data.serverSeed}
                                onClick={this.selectAll.bind(this)}
                                readOnly
                            />
                        </div>
                    </div>
                </div>

                <div className="section client">

                    <div className="header">
                        <div className="icon"></div>
                        <div className="description">
                            <div className="title">
                                {lang["client seed"]}
                            </div>
                            <div className="value">
                                {lang["client tip"]}
                            </div>
                        </div>
                    </div>

                    <div className="list">
                        {this.renderClientSeed(data.playerSeeds[0])}
                        {this.renderClientSeed(data.playerSeeds[1])}
                        {this.renderClientSeed(data.playerSeeds[2])}
                    </div>
                </div>

                <div className="section hash">

                    <div className="header">
                        <div className="icon"></div>
                        <div className="description">
                            <div className="title">
                                {lang.hash}
                            </div>
                            <div className="value">
                                {lang["hash tip"]}
                            </div>
                        </div>
                    </div>

                    <div className="list">
                        <div className="item">
                            <input 
                                type="text"
                                value={data.sha}
                                onClick={this.selectAll.bind(this)}
                                readOnly
                            />
                        </div>
                    </div>
                </div>

                <div className="section result vertical">
                    <div className="header">
                        {lang.hex}
                    </div>
                    <div className="list">
                        <div className="item">
                            {data.hex}
                        </div>
                    </div>

                    <div className="header">
                        {lang.decimal}
                    </div>
                    <div className="list">
                        <div className="item">
                            {data.dec}
                        </div>
                    </div>

                    <div className="header">
                        {lang.result}
                    </div>
                    <div className="list">
                        <div className="item">
                            {data.roundMultiplier.toFixed(2)}
                        </div>
                    </div>
                </div>

                <div className="section result horizontal">
                    <div className="header">
                        <div className="cell">
                            {lang.hex}
                        </div>
                        <div className="cell">
                            {lang.decimal}
                        </div>
                        <div className="cell">
                            {lang.result}
                        </div>
                    </div>
                    <div className="list">
                        <div className="item">
                            <div className="cell">
                                {data.hex}
                            </div>
                            <div className="cell">
                                {data.dec}
                            </div>
                            <div className="cell">
                                {data.roundMultiplier.toFixed(2)}
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )

    }


    renderClientSeed(data?: any)
    {
        const lang = window.lang.shared.modals["fairness"];

        if (data)
        {
            return (
                <div className="item">
                    <div className="player">
                        <div className="title">
                            {Common.replaceTextValue(lang.player, {value: "1"})}
                        </div>
                        <div className="value">
                            <img 
                                src={"gfx/avatars/av-" + 1 + ".png?version=" + version}
                            />
                            <div className="username">
                                h***a
                            </div>
                        </div>
                    </div>
                    <div className="seed">
                        <div className="title">
                            {lang.seed}
                        </div>
                        <div className="value">
                            JRB9KSIejkQyJQjuKzZl
                        </div>
                    </div>
                </div>
            );
        }
        
        return (
            <div className="item empty">
                {lang["not enough"]}
            </div>
        );

    }


}

export namespace CheckFairness
{


    export interface Props
    {
        roundId: string;
    }


    export interface State
    {
        data?: {
            roundMultiplier: number;
            timestamp: string;
            serverSeed: string;
            playerSeeds: Array<{
                user: string;
                seed: string;
            }>;
            
            sha: string;
            hex: string;
            dec: string;
        };
    }


}